export enum CardErrorCategory {
    cardInvalidInputError = 'cardInvalidInputError',
    cardUsageLimitError = 'cardUsageLimitError',
    cardRejectionError = 'cardRejectionError',
    cardUnsupportedError = 'cardUnsupportedError',
    cardRetryError = 'cardRetryError', // default error
    cardUnusableError = 'cardUnusableError',
}

export const CardErrors = new Map<string, CardErrorCategory>([
    // カード情報の入力の問題
    ['incorrect_number', CardErrorCategory.cardInvalidInputError],
    ['incorrect_cvc', CardErrorCategory.cardInvalidInputError],
    ['incorrect_pin', CardErrorCategory.cardInvalidInputError],
    ['incorrect_zip', CardErrorCategory.cardInvalidInputError],
    ['invalid_cvc', CardErrorCategory.cardInvalidInputError],
    ['invalid_expiry_month', CardErrorCategory.cardInvalidInputError],
    ['invalid_expiry_year', CardErrorCategory.cardInvalidInputError],
    ['invalid_number', CardErrorCategory.cardInvalidInputError],
    ['invalid_pin', CardErrorCategory.cardInvalidInputError],
    // 残高 / 限度額オーバー
    ['withdrawal_count_limit_exceeded', CardErrorCategory.cardUsageLimitError],
    ['card_velocity_exceeded', CardErrorCategory.cardUsageLimitError],
    ['invalid_amount', CardErrorCategory.cardUsageLimitError],
    ['insufficient_funds', CardErrorCategory.cardUsageLimitError],
    // カード情報の入力の問題
    ['revocation_of_all_authorizations', CardErrorCategory.cardRejectionError],
    // カード拒否
    ['revocation_of_authorization', CardErrorCategory.cardRejectionError],
    ['security_violation', CardErrorCategory.cardRejectionError],
    ['service_not_allowed', CardErrorCategory.cardRejectionError],
    ['stop_payment_order', CardErrorCategory.cardRejectionError],
    ['transaction_not_allowed', CardErrorCategory.cardRejectionError],
    ['call_issuer', CardErrorCategory.cardRejectionError],
    ['do_not_honor', CardErrorCategory.cardRejectionError],
    ['do_not_try_again', CardErrorCategory.cardRejectionError],
    ['generic_decline', CardErrorCategory.cardRejectionError],
    ['new_account_information_available', CardErrorCategory.cardRejectionError],
    ['no_action_taken', CardErrorCategory.cardRejectionError],
    ['not_permitted', CardErrorCategory.cardRejectionError],
    ['restricted_card', CardErrorCategory.cardRejectionError],
    ['lost_card', CardErrorCategory.cardRejectionError],
    ['merchant_blacklist', CardErrorCategory.cardRejectionError],
    ['fraudulent', CardErrorCategory.cardRejectionError],
    ['pickup_card', CardErrorCategory.cardRejectionError],
    ['stolen_card', CardErrorCategory.cardRejectionError],
    // カード未対応
    ['card_not_supported', CardErrorCategory.cardUnsupportedError],
    ['currency_not_supported', CardErrorCategory.cardUnsupportedError],
    // 決済エラー&再試行依頼
    ['approve_with_id', CardErrorCategory.cardRetryError],
    ['processing_error', CardErrorCategory.cardRetryError],
    ['reenter_transaction', CardErrorCategory.cardRetryError],
    ['issuer_not_available', CardErrorCategory.cardRetryError],
    ['try_again_later', CardErrorCategory.cardRetryError],
    ['authentication_required', CardErrorCategory.cardRetryError],
    ['duplicate_transaction', CardErrorCategory.cardRetryError],
    // カード利用NG
    ['expired_card', CardErrorCategory.cardUnusableError],
    ['offline_pin_required', CardErrorCategory.cardUnusableError],
    ['online_or_offline_pin_required', CardErrorCategory.cardUnusableError],
    ['pin_try_exceeded', CardErrorCategory.cardUnusableError],
    ['testmode_decline', CardErrorCategory.cardUnusableError],
])
